import { types } from './actions';

const initialState = {
  isMergeModalOpen: false,
  isMergingQuoteItems: false,
  mergeError: null,
  mergeType: null,
  selectedQuoteItems: [],
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.CLOSE_MERGE_MODAL:
      return {
        ...state,
        isMergeModalOpen: false,
      };
    case types.OPEN_MERGE_MODAL:
      return {
        ...state,
        isMergeModalOpen: true,
        mergeError: null,
        mergeType: payload.mergeType,
        selectedQuoteItems: payload.selectedQuoteItems,
      };
    case types.MERGE_QUOTE_ITEMS_REQUEST:
      return {
        ...state,
        isMergingQuoteItems: true,
      };
    case types.MERGE_QUOTE_ITEMS_SUCCESS:
      return {
        ...state,
        isMergeModalOpen: false,
        isMergingQuoteItems: false,
        mergeError: null,
      };
    case types.MERGE_QUOTE_ITEMS_ERROR:
      return {
        ...state,
        isMergingQuoteItems: false,
        mergeError: payload,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.common.modals.mergeModal;

export const getIsMergeModalOpen = (state) => getScope(state).isMergeModalOpen;

export const getMergeType = (state) => getScope(state).mergeType;

export const getSelectedQuoteItems = (state) =>
  getScope(state).selectedQuoteItems;

export const getIsMergingQuoteItems = (state) =>
  getScope(state).isMergingQuoteItems;

export const getMergeError = (state) => getScope(state).mergeError;
